import {myGetJson,myPost} from './netOps.js';

export async function getWaterPurchases() {
    return await myGetJson('api/waterpurchase');
}

export async function setWaterPurchase(data) {
    return await myPost('api/waterpurchase/setTimesByName/', data);
}

export async function getPurchaseRecord(){
    return await myGetJson('api/purchaserecord');
}